import React from "react";

import { ButtonStandard, ModalBase } from "@performyard/py-components";

import AuditLog, { type CompensationAuditLogEntry } from "./AuditLog";

export type AuditLogModalProps = {
	onClose: () => void;
	entries: CompensationAuditLogEntry[];
};

export const AuditLogModal = ({ onClose, entries }: AuditLogModalProps): React.ReactElement => (
	<ModalBase isOpen onClose={onClose} dangerouslySetClassName="w-[432px]">
		<div className="flex w-full flex-col items-stretch">
			<div className="px-6 pb-4">
				<AuditLog title="Audit Log" emptyStateLabel="No activity yet" entries={entries} />
			</div>
			<div className="mb-6 flex shrink-0 justify-center px-6">
				<ButtonStandard color="primary" size="large" onClick={onClose} dangerouslySetClassName="w-[90px]">
					Close
				</ButtonStandard>
			</div>
		</div>
	</ModalBase>
);
